<template>
  <div :class="$style['container']">
    <div :class="$style['welcome-text']">
      Welcome back {{ user }}!
    </div>
    <div v-if="isMaster" :class="$style['amounts-container']">
        <div :class="$style['amounts-box']">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Starting Balance (Monthly):
            </span>
            <span :class="$style['amounts-box-value']">
              {{ initialAssets !== null ? formatToUSD(initialAssets) : '--' }}
            </span>
          </div>
        </div>
        <div :class="[$style['amounts-box'], $style['light-blue']]">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Current assets:
            </span>
            <span :class="$style['amounts-box-value']">
              {{ currentAssets !== null ? formatToUSD(currentAssets) : '--' }}
            </span>
          </div>
        </div>
        <div :class="[$style['amounts-box'], $style['blue']]">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Earnings for the month:
            </span>
            <span :class="$style['amounts-box-value']">
              {{ monthAssets !== null ? formatToUSD(monthAssets) : '--' }}
            </span>
          </div>
          <div :class="$style['amounts-box-info-right']">
            <span v-if="monthPercent" :class="$style['amounts-box-percent']">
              {{ Math.trunc(monthPercent * 100) / 100 }}%
            </span>
          </div>
        </div>
    </div>
    <div v-else :class="$style['amounts-container']">
        <div :class="$style['amounts-box']">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Net Invested Amount:
            </span>
            <span :class="[$style['amounts-box-value'], $style['nm']]">
              {{ initialAssets !== null ? formatToUSD(initialAssets) : '--' }}
            </span>
          </div>
        </div>
        <div :class="[$style['amounts-box'], $style['light-blue']]">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Current Balance:
            </span>
            <span :class="[$style['amounts-box-value'], $style['nm']]">
              {{ currentAssets !== null ? formatToUSD(currentAssets) : '--' }}
            </span>
          </div>
        </div>
        <div :class="[$style['amounts-box'], $style['blue']]">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Net Return:
            </span>
            <span :class="[$style['amounts-box-value'], $style['nm']]">
              {{ allGain !== null ? formatToUSD(allGain) : '--' }}
            </span>
          </div>
        </div>
        <div :class="[$style['amounts-box'], $style['yellow']]">
          <div :class="$style['amounts-box-infos']">
            <span :class="$style['amounts-box-title']">
              Earnings for the month:
            </span>
            <span :class="[$style['amounts-box-value'], $style['nm']]">
              {{ monthAssets !== null ? formatToUSD(monthAssets) : '--' }}
            </span>
          </div>
          <div :class="$style['amounts-box-info-right']">
            <span v-if="monthPercent" :class="[$style['amounts-box-percent'], $style['nm']]">
              {{ Math.trunc(monthPercent * 100) / 100 }}%
            </span>
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { formatToUSD } from '@/helpers/currencyFormatter';

export default {
  name: 'MonthlyInfo',

  props: {
    initialAssets: {
      type: Number,
      default: 0,
    },
    currentAssets: {
      type: Number,
      default: 0,
    },
    monthAssets: {
      type: Number,
      default: 0,
    },
    monthPercent: {
      type: Number,
      default: 0,
    },
    allGain: {
      type: Number,
      default: 0,
    }
  },

  data() {
    return {
      user: this.$store.state.auth.user,
    }
  },
  methods: {
    formatToUSD,
  },
  computed: {
    isMaster() {
      return this.$store.getters['auth/isMaster'];
    }
  },
}
</script>

<style lang="scss" module>
  .container {
    height: fit-content;
  }

  .welcome-text {
    color: #D9D9D9;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 42px;
    height: fit-content;
    width: 100%;
    font-family: $font-default;
    margin-bottom: 10px;

    @include respond-to(null, 'xs') {
      font-size: 24px !important;
    }
  }

  .amounts-container {
    display: grid;
    gap: 25px;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

    @include respond-to(null, 'sm') {
      gap: 10px !important;
      grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
    }

  }
  
  .amounts-box {
    border-radius: 16px;
    border: 1px solid rgba(124, 249, 92, 0.25);
    background: rgba(124, 249, 92, 0.15);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.10);
    display: flex;
    padding: 15px;
    gap: 10px;
    align-items: flex-start;

    @include respond-to(null, 'xs') {
      padding: 10px !important;
      flex-direction: column;
    }

    &-infos {
      flex: 1;
      display: flex;
      flex-direction: column;
    }

    &-title {
      color: #7CF95C;
      font-family: $font-default;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 26px;
    }

    &-value {
      color: #7CF95C;
      font-family: $font-default;
      font-size: 48px;
      font-style: normal;
      font-weight: 600;
      line-height: 58px;

      @include respond-to(null, 'xs') {
        font-size: 24px;
        line-height: normal;
      }

      &.nm {
        font-size: 38px !important;
      }
    }

    &-info-right {
      display: flex;
      height: 100%;
      align-items: center;

      @include respond-to(null, 'xs') {
        margin-left: 40%;
      }
    }

    &-percent {
      padding: 10px;border-radius: 4px;
      border: 1px solid #2FE0D5;
      color: #2FE0D5;
      font-family: $font-default;
      font-size: 26px;
      font-style: normal;
      font-weight: 600;
      line-height: 36px;

      &.nm {
        font-size: 18px !important;
      }

      @include respond-to(null, 'xs') {
        font-size: 38px;
        font-size: 20px;
        padding: 8px;
      }
    }

    &.blue {
      border: 1px solid rgba(53, 122, 255, 0.25);
      background: rgba(53, 122, 255, 0.25);

      @include respond-to(null, 'xs') {
        .amounts-box-info-right {
          justify-content: center !important;
        }

        .amounts-box-percent {
          padding: 6px;
          line-height: normal;
        }
      }

      .amounts-box-title,
      .amounts-box-value,
      .amounts-box-percent {
        color: #357AFF;
      }

      .amounts-box-percent {
        border: 1px solid #357AFF;
      }
    }

    &.light-blue {
      border: 1px solid rgba(47, 224, 213, 0.25);;
      background: rgba(47, 224, 213, 0.25);;

      .amounts-box-title,
      .amounts-box-value,
      .amounts-box-percent {
        color: #2FE0D5;
      }

      .amounts-box-percent {
        border: 1px solid #2FE0D5;
      }
    }

    &.yellow {
      border: 1px solid rgba(243, 186, 47, 0.25);;
      background: rgba(243, 186, 47, 0.25);;

      .amounts-box-title,
      .amounts-box-value,
      .amounts-box-percent {
        color: #F3BA2F;
      }

      .amounts-box-percent {
        border: 1px solid #F3BA2F;
      }
    }
    
  }
</style>
